import { isAbhaEnabled } from '@/config/features';
import { getFeatureStatus } from '@/services/Api';

const state = {
  // Initialize from environment variable
  abhaEnabled: isAbhaEnabled(),
  serverFeatures: null,
  isLoaded: false
};

const getters = {
  /**
   * Get ABHA enabled status from store
   */
  isAbhaEnabled: (state) => {
    return state.abhaEnabled;
  },

  /**
   * Determine if ABHA features should be shown
   * This is the main getter used by components
   */
  shouldShowAbhaFeatures: (state) => {
    // If server features are loaded, use those (they override env)
    // Otherwise use the environment variable value
    return state.serverFeatures?.abha?.enabled ?? state.abhaEnabled;
  },

  /**
   * Get all server features
   */
  getServerFeatures: (state) => state.serverFeatures
};

const mutations = {
  /**
   * Update ABHA enabled status from environment
   */
  SET_ABHA_FROM_ENV(state) {
    const envEnabled = isAbhaEnabled();
    console.log('Setting ABHA from ENV:', envEnabled);
    state.abhaEnabled = envEnabled;
  },

  /**
   * Update features from server response
   */
  SET_SERVER_FEATURES(state, features) {
    console.log('Setting server features:', features);
    state.serverFeatures = features;
    state.isLoaded = true;
    
    // If server provides ABHA status, update local state
    if (features?.abha?.enabled !== undefined) {
      state.abhaEnabled = features.abha.enabled;
    }
  },

  /**
   * Reset features to default state
   */
  RESET_FEATURES(state) {
    state.abhaEnabled = isAbhaEnabled();
    state.serverFeatures = null;
    state.isLoaded = false;
  }
};

const actions = {
  /**
   * Fetch feature status from server
   */
  async fetchFeatureStatus({ commit }) {
    try {
      console.log('Fetching feature status from server...');
      const response = await getFeatureStatus();
      
      if (response?.data) {
        commit('SET_SERVER_FEATURES', response.data);
        console.log('✅ Feature status fetched successfully');
        return response.data;
      }
      
      console.warn('⚠️ No feature data received from server');
      return null;
    } catch (error) {
      console.error('❌ Failed to fetch feature status:', error);
      // On error, fall back to environment variable
      commit('SET_ABHA_FROM_ENV');
      return null;
    }
  },

  /**
   * Update ABHA status from environment variable
   * Useful when .env file changes or for manual refresh
   */
  updateAbhaStatusFromEnv({ commit }) {
    commit('SET_ABHA_FROM_ENV');
  },

  /**
   * Reset features to initial state
   */
  resetFeatures({ commit }) {
    commit('RESET_FEATURES');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};